export const FETCH_MASTER_MAPPING_REQUEST = 'FETCH_MASTER_MAPPING_REQUEST';
export const FETCH_MASTER_MAPPING_SUCCESS = 'FETCH_MASTER_MAPPING_SUCCESS';
export const FETCH_MASTER_MAPPING_FAILURE = 'FETCH_MASTER_MAPPING_FAILURE';

export const FETCH_DETAILS_REQUEST = 'FETCH_DETAILS_REQUEST';
export const FETCH_DETAILS_SUCCESS = 'FETCH_DETAILS_SUCCESS';
export const FETCH_DETAILS_FAILURE = 'FETCH_DETAILS_FAILURE';

export const FETCH_REPORT_GROUP_REQUEST = 'FETCH_REPORT_GROUP_REQUEST';
export const FETCH_REPORT_GROUP_SUCCESS = 'FETCH_REPORT_GROUP_SUCCESS';
export const FETCH_REPORT_GROUP_FAILURE = 'FETCH_REPORT_GROUP_FAILURE';

export const FETCH_REPORT_FS_NOTES_REQUEST = 'FETCH_REPORT_FS_NOTES_REQUEST';
export const FETCH_REPORT_FS_NOTES_SUCCESS = 'FETCH_REPORT_FS_NOTES_SUCCESS';
export const FETCH_REPORT_FS_NOTES_FAILURE = 'FETCH_REPORT_FS_NOTES_FAILURE';

export const FETCH_REPORT_FS_LINES_REQUEST = 'FETCH_REPORT_FS_LINES_REQUEST';
export const FETCH_REPORT_FS_LINES_SUCCESS = 'FETCH_REPORT_FS_LINES_SUCCESS';
export const FETCH_REPORT_FS_LINES_FAILURE = 'FETCH_REPORT_FS_LINES_FAILURE';

export const FETCH_REPORT_AGGREGATE_REQUEST = 'FETCH_REPORT_AGGREGATE_REQUEST';
export const FETCH_REPORT_AGGREGATE_SUCCESS = 'FETCH_REPORT_AGGREGATE_SUCCESS';
export const FETCH_REPORT_AGGREGATE_FAILURE = 'FETCH_REPORT_AGGREGATE_FAILURE';

export const FETCH_REPORT_TESTING_SHEET_REQUEST = 'FETCH_REPORT_TESTING_SHEET_REQUEST';
export const FETCH_REPORT_TESTING_SHEET_SUCCESS = 'FETCH_REPORT_TESTING_SHEET_SUCCESS';
export const FETCH_REPORT_TESTING_SHEET_FAILURE = 'FETCH_REPORT_TESTING_SHEET_FAILURE';

export const FETCH_REPORT_CAP_REQUEST = 'FETCH_REPORT_CAP_REQUEST';
export const FETCH_REPORT_CAP_SUCCESS = 'FETCH_REPORT_CAP_SUCCESS';
export const FETCH_REPORT_CAP_FAILURE = 'FETCH_REPORT_CAP_FAILURE';

export const FETCH_REPORT_PAP_REQUEST = 'FETCH_REPORT_PAP_REQUEST';
export const FETCH_REPORT_PAP_SUCCESS = 'FETCH_REPORT_PAP_SUCCESS';
export const FETCH_REPORT_PAP_FAILURE = 'FETCH_REPORT_PAP_FAILURE';

// Report Master Mapping
export const fetchMasterMappingRequest = () => ({
    type: FETCH_MASTER_MAPPING_REQUEST,
});

export const fetchMasterMappingSuccess = (data) => ({
    type: FETCH_MASTER_MAPPING_SUCCESS,
    payload: data,
});

export const fetchMasterMappingFailure = (error) => ({
    type: FETCH_MASTER_MAPPING_FAILURE,
    payload: error,
});

// Details
export const fetchDetailsRequest = (engagementCode, branchSubCode) => ({
    type: FETCH_DETAILS_REQUEST,
    payload: { engagementCode, branchSubCode },
});

export const fetchDetailsSuccess = (data) => ({
    type: FETCH_DETAILS_SUCCESS,
    payload: data,
});

export const fetchDetailsFailure = (error) => ({
    type: FETCH_DETAILS_FAILURE,
    payload: error,
});

// Report Group
export const fetchReportGroupRequest = (engagementCode, branchSubCode) => ({
    type: FETCH_REPORT_GROUP_REQUEST,
    payload: { engagementCode, branchSubCode },
});

export const fetchReportGroupSuccess = (data) => ({
    type: FETCH_REPORT_GROUP_SUCCESS,
    payload: data,
});

export const fetchReportGroupFailure = (error) => ({
    type: FETCH_REPORT_GROUP_FAILURE,
    payload: error,
});

// Report FS Notes
export const fetchReportFSNotesRequest = (engagementCode, branchSubCode) => ({
    type: FETCH_REPORT_FS_NOTES_REQUEST,
    payload: { engagementCode, branchSubCode },
});

export const fetchReportFSNotesSuccess = (data) => ({
    type: FETCH_REPORT_FS_NOTES_SUCCESS,
    payload: data,
});

export const fetchReportFSNotesFailure = (error) => ({
    type: FETCH_REPORT_FS_NOTES_FAILURE,
    payload: error,
});

// Report FS Lines
export const fetchReportFSLinesRequest = (engagementCode, branchSubCode) => ({
    type: FETCH_REPORT_FS_LINES_REQUEST,
    payload: { engagementCode, branchSubCode },
});

export const fetchReportFSLinesSuccess = (data) => ({
    type: FETCH_REPORT_FS_LINES_SUCCESS,
    payload: data,
});

export const fetchReportFSLinesFailure = (error) => ({
    type: FETCH_REPORT_FS_LINES_FAILURE,
    payload: error,
});

// Report Aggregate
export const fetchReportAggregateRequest = (engagementCode, branchSubCode) => ({
    type: FETCH_REPORT_AGGREGATE_REQUEST,
    payload: { engagementCode, branchSubCode },
});

export const fetchReportAggregateSuccess = (data) => ({
    type: FETCH_REPORT_AGGREGATE_SUCCESS,
    payload: data,
});

export const fetchReportAggregateFailure = (error) => ({
    type: FETCH_REPORT_AGGREGATE_FAILURE,
    payload: error,
});

// Report Testing Sheet
export const fetchReportTestingSheetRequest = (engagementCode, branchSubCode) => ({
    type: FETCH_REPORT_TESTING_SHEET_REQUEST,
    payload: { engagementCode, branchSubCode },
});

export const fetchReportTestingSheetSuccess = (data) => ({
    type: FETCH_REPORT_TESTING_SHEET_SUCCESS,
    payload: data,
});

export const fetchReportTestingSheetFailure = (error) => ({
    type: FETCH_REPORT_TESTING_SHEET_FAILURE,
    payload: error,
});

// Report CAP
export const fetchReportCAPRequest = (engagementCode, branchSubCode) => ({
    type: FETCH_REPORT_CAP_REQUEST,
    payload: { engagementCode, branchSubCode },
});

export const fetchReportCAPSuccess = (data) => ({
    type: FETCH_REPORT_CAP_SUCCESS,
    payload: data,
});

export const fetchReportCAPFailure = (error) => ({
    type: FETCH_REPORT_CAP_FAILURE,
    payload: error,
});

// Report PAP
export const fetchReportPAPRequest = (engagementCode, branchSubCode) => ({
    type: FETCH_REPORT_PAP_REQUEST,
    payload: { engagementCode, branchSubCode },
});

export const fetchReportPAPSuccess = (data) => ({
    type: FETCH_REPORT_PAP_SUCCESS,
    payload: data,
});

export const fetchReportPAPFailure = (error) => ({
    type: FETCH_REPORT_PAP_FAILURE,
    payload: error,
});
